import { AddEditUserPageComponent } from "./add-edit-user-page.component";
import { AddEditUserActionsModalComponent } from "./addEditUserActionsModal/add-edit-user-actions.component";
import { SubordinatesInBuModule } from "./subordinatesInBu/subordinates-in-bu.module";
export const AddEditUserPageModule = angular
    .module('addEditUserPage', [SubordinatesInBuModule])
    .component(AddEditUserPageComponent.selector, AddEditUserPageComponent.component)
    .component(AddEditUserActionsModalComponent.selector, AddEditUserActionsModalComponent.component)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('missioncontrol.usermanagement', {
            url: '/user',
            component: AddEditUserPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                accessMode: null,
                userId: null,
                manager: null,
                purpose: null
            }
        });
    }])
    .constant('USERMANAGEMENTCONSTANTS', {
    CONTROLLER: {
        SAVE_USER: 'api/user/saveuser',
        UPDATE_USER: 'api/user/updateuser',
    }
})
    .filter('unique', () => {
    return (collection, keyname) => {
        var output = [], keys = [];
        angular.forEach(collection, (item) => {
            var key = item[keyname];
            if (keys.indexOf(key) === -1) {
                keys.push(key);
                output.push(item);
            }
        });
        return output;
    };
})
    .name;
//# sourceMappingURL=add-edit-user-page.module.js.map